import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import useLanguageChange from "../../hooks/useLanguageChange";
import { reverseArray } from "../../shared/utility";
import { deleteUploadFileContainerImageByName } from "../../reducers/uploadFile-reducer";
import { Fancybox } from "../../shared/FancyboxJS";

const UploadFileContainerDrawer = () => {
    const dispatch = useDispatch();
    const fancyRef = useRef();

    const { uploadFileContainerImages } = useSelector((state) => state.uploadFile);

    const [showContainer, setShowContainer] = useState(false);
    const [displayContainer, setDisplayContainer] = useState(false);

    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change */
    const localisedValues = useLanguageChange();

    useEffect(() => {
        setDisplayContainer(uploadFileContainerImages.length > 0);

        if (uploadFileContainerImages.length === 0) {
            setShowContainer(false); //remove active class if list become empty so that on next capture it won't be shown open
        }
    }, [uploadFileContainerImages]);

    const facyBoxButtons = useMemo(() => {
        return ["slideshow", "fullscreen", "close"];
    }, []);

    const toggleContainerView = () => {
        setShowContainer((prevState) => {
            return !prevState;
        });
    };

    const deleteImageClickHandler = (imageName) => {
        dispatch(deleteUploadFileContainerImageByName(imageName));
    };

    return (
        // add active class when
        <div className={clsx("sidebar right-sidebar saved-image-sidebar", !displayContainer && "d-none", showContainer && "active")}>
            <div className='capture-image-count'>
                <button className='btn btn-primary capture-image-count-btn' onClick={() => toggleContainerView()}>
                    <span className='btn-icon icon-left-arrow'></span>
                    <span className='btn-text'>{uploadFileContainerImages.length}</span>
                </button>
            </div>
            <div className='sidebar-in'>
                <div className='sidebar-head'>
                    <div className='sidebar-head-title'>
                        <div className='sidebar-head-icon'>
                            <span className='for-icon icon-image'></span>
                        </div>
                        <div className='title'>{localisedValues?.capture_image}</div>
                    </div>
                    <div className='sidebar-head-right'>
                        <div className='sidebar-close'>
                            <button className='btn' onClick={() => toggleContainerView()}>
                                <span className='for-icon icon-close-light'></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className='sidebar-body custom-scroll'>
                    <div className='saved-image-list'>
                        <Fancybox
                            fancyRef={fancyRef}
                            options={{
                                Hash: false,
                                Carousel: {
                                    infinite: false,
                                },
                                Toolbar: {
                                    display: {
                                        left: ["infobar"],
                                        middle: [],
                                        right: facyBoxButtons,
                                    },
                                },
                                Thumbs: false,
                            }}
                        >
                            {reverseArray(uploadFileContainerImages).map((image, index) => (
                                <div className='saved-image-col' key={`uploadFileContainerImage_${index}`}>
                                    <div className='saved-image-box'>
                                        <div className='saved-image-top'>
                                            <a
                                                className='open-saved-image'
                                                data-fancybox='session-image'
                                                href={image.imageData}
                                                onClick={() => {
                                                    /* Hide download button for iOS */
                                                }}
                                            >
                                                <div className='view-button'>
                                                    <div className='view-btn'>
                                                        <span className='for-text'>{localisedValues?.view_text}</span>
                                                    </div>
                                                </div>
                                                <div className='saved-image-wrap'>
                                                    <img className='saved-image-img' src={image.imageData} id={index} alt='Capture Image' />
                                                </div>
                                            </a>
                                            <div className='delete-image custom-tooltip tooltip-auto-width m-hide'>
                                                <button
                                                    className='btn delete-btn'
                                                    onClick={() => {
                                                        deleteImageClickHandler(image.imageName);
                                                    }}
                                                >
                                                    <span className='btn-icon icon-close-light'></span>
                                                </button>
                                                <div className='custom-tooltip-content text-nowrap'>
                                                    <div className='custom-tooltip-in'>
                                                        <p>{localisedValues?.delete_lable}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='saved-image-info'>
                                            <div className='saved-image-name'>
                                                <div className='saved-image-icon'>
                                                    <span className='for-icon icon-image'></span>
                                                </div>
                                                <div className='name'>
                                                    {image.isLocationImage
                                                        ? localisedValues?.location_image_thumb_caption
                                                        : localisedValues?.image_thumb_caption}{" "}
                                                    {uploadFileContainerImages.length - index}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Fancybox>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default UploadFileContainerDrawer;
